import React from 'react'
import { Link } from 'react-router-dom';
import Contact_01 from '../../assets/images/svg/addres-icon-2.svg';
import Contact_02 from '../../assets/images/svg/mail-icon-2.svg';
import Contact_03 from '../../assets/images/svg/call-icon-2.svg';


const Contact = () => {
    return (
        <>
            <div className="contact-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6">
                            <div
                                className="contact-info animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="heading-box">
                                    <span
                                        className="sub-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        Contact
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        Get free business consultation Today
                                    </h2>
                                </div>
                                <ul>
                                    <li>
                                        <img src={Contact_01} alt="icon" />
                                        <div className="contact-title">
                                            <h6>Address Business</h6>
                                            <p>2220 Plymouth Rd #302 Hopkins, Minnesota(MN), 55305 </p>
                                        </div>
                                    </li>
                                    <li>
                                        <img src={Contact_02} alt="icon" />
                                        <div className="contact-title">
                                            <h6>Email Address</h6>
                                            <Link to="mailto:uniqoconsulting@gmail.com">
                                                uniqoconsulting@gmail.com
                                            </Link>
                                            <Link to="mailto:uniqoconsultingcareers@gmail.com">
                                                uniqoconsultingcareers@gmail.com
                                            </Link>
                                        </div>
                                    </li>
                                    <li>
                                        <img src={Contact_03} alt="icon" />
                                        <div className="contact-title">
                                            <h6>Phone Number</h6>
                                            <Link to="telto:(234) 109-6666">
                                                Call Consulting: (234) 109-6666
                                            </Link>
                                            <Link to="telto:(234) 244-8888">
                                                Call Cooperate: (234) 244-8888
                                            </Link>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-6">
                            <div
                                className="contact-form animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <form action="#">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Name"
                                        />
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="number"
                                            name="number"
                                            className="form-control"
                                            placeholder="Phone number"
                                        />
                                        <input
                                            type="text"
                                            name="need"
                                            className="form-control"
                                            placeholder="what are you needs"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <textarea
                                            name="message"
                                            className="form-control"
                                            placeholder="Message"
                                            rows={4}
                                            defaultValue={""}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-secondary btn-theme">
                                        Send
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Contact
